import { toDate as a } from "./toDate.js";
function d(e) {
  let t = a(e).getDay();
  return t === 0 && (t = 7), t;
}
export {
  d as default,
  d as getISODay
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getISODay.js
// module id = 1344
// module chunks = 41